import { render } from "./Weeks.vue?vue&type=template&id=3fb7edcd"
import script from "./Weeks.vue?vue&type=script&lang=js"
export * from "./Weeks.vue?vue&type=script&lang=js"

import "./Weeks.vue?vue&type=style&index=0&id=3fb7edcd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__